import { createFileRoute } from '@tanstack/react-router'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute('/_dashboard/mcp-auth-callback')({
  staticData: { title: 'MCP Authentication' },

  component: lazyLoadedComponent(
    () => import('#app/pages/auth/mcp-auth-callback'),
    'McpAuthCallback',
  ),
})
